import React from 'react';
import TagManager from '@sooro-io/react-gtm-module';
import Header from '../../components/layout/Header';
import Login from '../../user/Login';
import MetaTags from '../../components/MetaTags';
import { defaultImageUrl, primaryImageUrl } from '../services/Quote';
TagManager.dataLayer({
  dataLayer: {
    event: 'pageview',
    pagePath: '/admin/login',
    pageTitle: 'Portal',
  },
});
const Index = () => {
  return (
    <div>
      <MetaTags
        title="A&E Financial Services - Portal. Read | taxes | processes"
        description="Discover A&E Financial Services, your trusted source for personalized insurance, read taxes, and financial solutions, including expert tax services and efficient processes, catering to your various insurance needs 24/7."
        keywords="Income tax in Houston,Income tax preparation in Houston,Tax office near Stafford,Tax office near 77036,Tax office near 77082,Tax office near 77099,Tax office near 77007,Tax office near 77479,Tax office near 77401,Tax office near 77489, Taxes, Financial, Financial Services, read, processes"
        url="https://www.aefinancialservicesllc.com"
        imageUrl={primaryImageUrl || defaultImageUrl}
      />
      <Header headerType="relative" />
      <Login />
    </div>
  );
};

export default Index;
